module.exports = __webpack_public_path__ + "img/step-4-mobile.6a2e2a27.gif";